import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import AboutPage from "./pages/AboutPage";
import RangePage from "./pages/RangePage";
import QualityPage from "./pages/QualityPage";
import QuotePage from "./pages/QuotePage";
import ContactPage from "./pages/ContactPage";
import NotFound from "./pages/NotFound";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./i18n/LanguageContext";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/range" element={<RangePage />} />
              <Route path="/catalog" element={<Navigate to="/range" replace />} />
              <Route path="/credentials" element={<Navigate to="/quality" replace />} />
              <Route path="/quality" element={<QualityPage />} />
              <Route path="/quote" element={<QuotePage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </LanguageProvider>
    </div>
  );
}

export default App;
